import { Label, useStyles } from '@archipro-design/aria';
import { PanelTitle } from './ShippingPanel.style';
import { useLoaderData } from '@remix-run/react';
import ShippingOption from './ShippingOption';
import type { ItemShippingType } from '@modules/ecommerce/context/ItemShippingContext';
import { makeShippingOption } from '@modules/ecommerce/context/ItemShippingContext';
import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';

interface Props {
    shipping: ItemShippingType | null;
    onChange: (shipping: ItemShippingType) => void;
}

const ClickAndCollectSelect = ({ shipping, onChange }: Props) => {
    const { css } = useStyles();

    const { product } = useLoaderData<ProductPageLoaderData>();

    const pickupLocation = product.Professional?.PickupLocations ?? [];
    const selectedID =
        shipping && shipping.type === 'clickAndCollect' && shipping.ID;
    return (
        <div>
            <Label variant="01" className={css(PanelTitle)} weight="medium">
                Click &amp; Collect
            </Label>
            {pickupLocation.map((l) => (
                <ShippingOption
                    key={'pickup-location-' + l.ID}
                    selected={l.ID === selectedID}
                    title={l.Title}
                    subTitle={
                        <span>
                            {l.PickupEstimateText}
                            <br />
                            {l.FormattedAddress}
                        </span>
                    }
                    onClick={() =>
                        onChange(makeShippingOption('clickAndCollect', l.ID))
                    }
                />
            ))}
        </div>
    );
};

export default ClickAndCollectSelect;
